import { render, staticRenderFns } from "./AdminAddFileTwo.vue?vue&type=template&id=203fe609&"
import script from "./AdminAddFileTwo.vue?vue&type=script&lang=js&"
export * from "./AdminAddFileTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports